<template>
	<div style="position: relative; height: 340px; width: 100%;">
		<canvas ref="cv"></canvas>
	</div>
</template>

<script>
import Chart from 'chart.js';

// AI Query 결과를 chart.js 로 렌더. spec(=buildChartSpec 결과)이 바뀌면 재생성.
export default {
	name: 'NlqChart',
	props: {
		spec: { type: Object, default: null },
	},
	data: () => ({ chart: null }),
	mounted() {
		this.render();
	},
	beforeDestroy() {
		this.destroy();
	},
	watch: {
		spec() {
			this.render();
		},
	},
	methods: {
		destroy() {
			if (this.chart) {
				this.chart.destroy();
				this.chart = null;
			}
		},
		render() {
			this.destroy();
			if (!this.spec || !this.$refs.cv) return;
			this.chart = new Chart(this.$refs.cv, this.spec);
		},
	},
};
</script>

<style scoped></style>
